<template>
  <div class="bg-white">
    <TemporaryMediaUpload :options="options" @file-uploaded="onFileUploaded" />

    <ul v-if="value.length" class="divide-y divide-gray-200 mt-8">
      <slot :handle-remove="removeTemporaryMediaUpload">
        <TemporaryMediaUploadList
          :temporary-media-uploads="value"
          :on-remove="removeTemporaryMediaUpload"
        />
      </slot>
    </ul>
  </div>
</template>

<script>
import { temporaryMediaUploadsClient } from '@/api/clients';

import TemporaryMediaUpload from './TemporaryMediaUpload.vue';
import TemporaryMediaUploadList from './TemporaryMediaUploadList.vue';

export default {
  components: {
    TemporaryMediaUpload,
    TemporaryMediaUploadList,
  },
  props: {
    value: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      //
    };
  },
  created() {
    this.fetchTemporaryMediaUploads();
  },
  methods: {
    async fetchTemporaryMediaUploads() {
      try {
        const {
          data: { data: temporaryMediaUploads },
        } = await temporaryMediaUploadsClient.list();

        this.$emit('input', [...temporaryMediaUploads]);
      } catch (error) {
        //
      }
    },
    async removeTemporaryMediaUpload(temporaryMediaUpload) {
      try {
        await temporaryMediaUploadsClient.destroy(temporaryMediaUpload.id);

        this.$emit('input', [...this.value.filter((item) => item.id !== temporaryMediaUpload.id)]);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async onFileUploaded() {
      if (!this.options?.allowMultiple) {
        await Promise.all(this.value.map((item) => temporaryMediaUploadsClient.destroy(item.id)));
      }
      this.fetchTemporaryMediaUploads();
    },
  },
};
</script>
